/* DeviceCaptureStatusComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./DeviceCaptureStatusRenderer");

class DeviceCaptureStatusColumnComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setCaptureStatus(newVal);
        }
    }

    getValue() {
        return this.getCaptureStatus();
    }

    setCaptureStatus(newVal) {
        this._value = newVal;
        this.emit("CaptureStatus", newVal);
        return this;
    }

    getCaptureStatus() {
        return this._value;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = DeviceCaptureStatusColumnComponent;
